var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8405 15.9085L19.5905 4.65849C19.1686 4.23685 18.5965 4 18 4C17.4035 4 16.8315 4.23685 16.4095 4.65849L5.15955 15.9085C4.9496 16.1169 4.78317 16.3649 4.66995 16.6382C4.55673 16.9115 4.49896 17.2046 4.50001 17.5004V31.0004C4.50001 31.2987 4.61854 31.5849 4.82952 31.7959C5.0405 32.0068 5.32665 32.1254 5.62501 32.1254H14.625C14.9234 32.1254 15.2095 32.0068 15.4205 31.7959C15.6315 31.5849 15.75 31.2987 15.75 31.0004V23.1254H20.25V31.0004C20.25 31.2987 20.3685 31.5849 20.5795 31.7959C20.7905 32.0068 21.0766 32.1254 21.375 32.1254H30.375C30.6734 32.1254 30.9595 32.0068 31.1705 31.7959C31.3815 31.5849 31.5 31.2987 31.5 31.0004V17.5004C31.5011 17.2046 31.4433 16.9115 31.3301 16.6382C31.2169 16.3649 31.0504 16.1169 30.8405 15.9085ZM29.25 29.8754H22.5V22.0004C22.5 21.702 22.3815 21.4158 22.1705 21.2049C21.9595 20.9939 21.6734 20.8754 21.375 20.8754H14.625C14.3266 20.8754 14.0405 20.9939 13.8295 21.2049C13.6185 21.4158 13.5 21.702 13.5 22.0004V29.8754H6.75001V17.5004L18 6.25036L29.25 17.5004V29.8754Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d3812f5c48597041b5f3258b24cf4ed8.svg";
export { ForwardRef as ReactComponent };